import { Tag } from 'antd';

import styles from './styles.module.css';

type SearchTagsProps = {
  search?: string;
  removeSearch: () => void;
};

const SearchTags = ({ search, removeSearch }: SearchTagsProps) => {
  return (
    <div className={styles.container} style={{ justifyContent: window.innerWidth <= 768 ? 'center' : 'left' }}>
      {search && (
        <Tag closeIcon onClose={removeSearch} className={styles.tag}>
          {search}
        </Tag>
      )}
    </div>
  );
};

export default SearchTags;
